import { serviceMaker, methods, api } from "./index.js";

export const getProspects = () =>
  serviceMaker("/prospects/allprospects", methods.GET, api.NGB);

export const getAllProspects = () =>
  serviceMaker(
    "/prospects/allprospects?limit=14&offset=0",
    methods.GET,
    api.NGB
  );
export const prospectCancel = (id, remark) =>
  serviceMaker(
    `/prospects/${id}?statusRemark=${remark}`,
    methods.DELETE,
    api.NGB
  );
export const getProspectTemplete = (id) =>
  serviceMaker(
    `/prospects/cancel/${id}
`,
    methods.GET,
    api.NGB
  );
export const putProspectCancel = (id, data) =>
  serviceMaker(`/prospects/followup/${id}`, methods.PUT, api.NGB, data);

export const putProspectTemplete = (id) =>
  serviceMaker(`/prospects/followup/${id}`, methods.GET, api.NGB);

export const getProspectsTemplate = () =>
  serviceMaker(`/prospects/template`, methods.GET, api.NGB);
export const getAddressTemplate = () =>
  serviceMaker(`/address/template`, methods.GET, api.NGB);
export const createProspects = (data) =>
  serviceMaker(`/prospects`, methods.POST, api.NGB, data);

export const getViewprospects = (id) =>
  serviceMaker(`/prospects/${id}`, methods.GET, api.NGB);
export const sendQuoteMail = (payload) =>
  serviceMaker(
    `quotes/email/${payload.quoteId}`,
    methods.PUT,
    api.NGB,
    payload
  );
export const getViewprospectshistory = (id) =>
  serviceMaker(`/prospects/${id}/history`, methods.GET, api.NGB);
export const getQuotesViewQuotes = (id) =>
  serviceMaker(`/quotes/viewquotes/${id}`, methods.GET, api.NGB);
export const getPlanPricingInfo = ({ productId, planId }) =>
  serviceMaker(
    `/rateplan/getRatesByProductsPlan/product/${productId}/plan/${planId}`,
    methods.GET,
    api.NGB
  );
export const getcCientsSearching = (id) =>
  serviceMaker(`/clients/searching/1/?query=`, methods.GET, api.NGB);
export const editProspects = (id, data) =>
  serviceMaker(`/prospects/${id}`, methods.PUT, api.NGB, data);
export const getAddress = (city) =>
  serviceMaker(`/address/template/${city}`, methods.GET, api.NGB);
export const getChargeCode = () =>
  serviceMaker(`/chargecode`, methods.GET, api.NGB);
export const getClientServiceTemplate = () =>
  serviceMaker(`/clientservice/template`, methods.GET, api.NGB);
export const getQuotesPlans = () =>
  serviceMaker(`/quotes/plans`, methods.GET, api.NGB);
export const createQuote = (id, data) =>
  serviceMaker(`/quotes/${id}`, methods.POST, api.NGB, data);
export const getPlanPricing = (chargeCode, id) =>
  serviceMaker(
    `/quotes/planpricing?chargecode=${chargeCode}&planId=${id}`,
    methods.GET,
    api.NGB
  );
export const getClientService = () =>
  serviceMaker(`/clientservice/template`, methods.GET, api.NGB);
export const getQuotes = (id, QuoteId) =>
  serviceMaker(
    `/quotes/viewquotes/${id}?quoteId=${QuoteId}`,
    methods.GET,
    api.NGB
  );
export const elevatePropspect = (id, data) =>
  serviceMaker(`/prospects/elevate/${id}`, methods.PUT, api.NGB, data);
export const getsStatus = (LeadId) =>
  serviceMaker(`/quotes/status?leadId=${LeadId}`, methods.GET, api.NGB);
export const convertToClient = (id, data) =>
  serviceMaker(`/prospects/converttoclient/${id}`, methods.POST, api.NGB, data);
export const editQuote = (id, data) =>
  serviceMaker(`/quotes/${id}`, methods.PUT, api.NGB, data);
export const acceptQuoteStatus = (id, data) =>
  serviceMaker(`/quotes/status/${id}`, methods.PUT, api.NGB, data);
export const cancelPropspect = (id) =>
  serviceMaker(`/prospects/cancel/${id}`, methods.GET, api.NGB);
export const deleteProspect = (id, statusRemark) =>
  serviceMaker(
    `/prospects/${id}?statusRemark=${statusRemark}`,
    methods.DELETE,
    api.NGB
  );
export const getTicketCustomer = () =>
  serviceMaker(`/tickets/alltickets?type=Customer`, methods.GET, api.NGB);
export const getLoc = (keyword) =>
  serviceMaker(`/clients/searching/1/?query=${keyword}`, methods.GET, api.NGB);
export const getFollowUp = (id) =>
  serviceMaker(`/prospects/followup/${id}`, methods.GET, api.NGB);
export const createFollowUp = (id, data) =>
  serviceMaker(`/prospects/followup/${id}`, methods.PUT, api.NGB, data);
export const assignTo = (id, data) =>
  serviceMaker(`/prospects/followup/assign/${id}`, methods.POST, api.NGB, data);
export const getCustomerId = (id) =>
  serviceMaker(
    `/clients/search/account_no?columnValue=${id}`,
    methods.GET,
    api.NGB
  );
